var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotobookLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 99 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.748047,
    y: 0.284546,
    width: 97.813,
    height: 86.7398,
    rx: 16.7621,
    fill: "#C0D8D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3474 57.8902C53.0687 58.058 53.1348 59.0028 52.4322 59.237L48.2839 60.6023C37.8605 63.963 32.3731 61.1537 28.9861 50.7303L25.6254 40.3594C22.2647 29.936 25.0478 24.4223 35.4712 21.0616L36.847 20.606C37.9047 20.2557 38.9341 21.3166 38.6338 22.3896C38.4849 22.9214 38.3417 23.4765 38.2018 24.0547L35.6288 35.0558C32.7407 47.4221 36.9678 54.2485 49.3341 57.1891L52.3474 57.8902Z",
    fill: "url(#paint0_linear_14_1232)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3474 57.8902C53.0687 58.058 53.1348 59.0028 52.4322 59.237L48.2839 60.6023C37.8605 63.963 32.3731 61.1537 28.9861 50.7303L25.6254 40.3594C22.2647 29.936 25.0478 24.4223 35.4712 21.0616L36.847 20.606C37.9047 20.2557 38.9341 21.3166 38.6338 22.3896C38.4849 22.9214 38.3417 23.4765 38.2018 24.0547L35.6288 35.0558C32.7407 47.4221 36.9678 54.2485 49.3341 57.1891L52.3474 57.8902Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7573 12.8964L64.142 13.9204C75.143 16.4934 78.5037 21.9283 75.9306 32.903L73.3576 43.8778C71.1522 53.356 66.7938 57.1893 58.6021 56.4017C57.2893 56.2966 55.8715 56.0603 54.3487 55.6928L49.9378 54.6425C38.9893 52.0433 35.6023 46.6346 38.1753 35.6599L40.7484 24.6588C41.2735 22.4271 41.9036 20.4842 42.6913 18.8826C45.7632 12.5288 50.988 10.8222 59.7573 12.8964Z",
    fill: "url(#paint1_linear_14_1232)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7573 12.8964L64.142 13.9204C75.143 16.4934 78.5037 21.9283 75.9306 32.903L73.3576 43.8778C71.1522 53.356 66.7938 57.1893 58.6021 56.4017C57.2893 56.2966 55.8715 56.0603 54.3487 55.6928L49.9378 54.6425C38.9893 52.0433 35.6023 46.6346 38.1753 35.6599L40.7484 24.6588C41.2735 22.4271 41.9036 20.4842 42.6913 18.8826C45.7632 12.5288 50.988 10.8222 59.7573 12.8964Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3682 74.3998L56.13 79.4207C55.3064 80.4108 54.0849 80.9835 52.7967 80.9835C51.5086 80.9835 50.2871 80.4108 49.4632 79.4207L45.4043 74.5303C44.6773 73.6585 44.3072 72.5434 44.3674 71.41C44.428 70.2762 44.9147 69.2074 45.7305 68.4178C46.613 67.6044 47.7948 67.1968 48.9904 67.293C50.1914 67.3806 51.299 67.9729 52.0387 68.923L52.8865 69.9336L53.6036 69.0695C54.3089 68.18 55.3253 67.591 56.4477 67.4215C57.5701 67.2524 58.715 67.5148 59.6511 68.1566C60.575 68.8902 61.1628 69.9664 61.2811 71.1399C61.435 72.3057 61.1051 73.4837 60.3683 74.3998H60.3682Z",
    fill: "url(#paint2_linear_14_1232)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3682 74.3998L56.13 79.4207C55.3064 80.4108 54.0849 80.9835 52.7967 80.9835C51.5086 80.9835 50.2871 80.4108 49.4632 79.4207L45.4043 74.5303C44.6773 73.6585 44.3072 72.5434 44.3674 71.41C44.428 70.2762 44.9147 69.2074 45.7305 68.4178C46.613 67.6044 47.7948 67.1968 48.9904 67.293C50.1914 67.3806 51.299 67.9729 52.0387 68.923L52.8865 69.9336L53.6036 69.0695C54.3089 68.18 55.3253 67.591 56.4477 67.4215C57.5701 67.2524 58.715 67.5148 59.6511 68.1566C60.575 68.8902 61.1628 69.9664 61.2811 71.1399C61.435 72.3057 61.1051 73.4837 60.3683 74.3998H60.3682Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_1232",
    x1: 30.5139,
    y1: 19.7226,
    x2: 68.4258,
    y2: 50.2641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_1232",
    x1: 45.4512,
    y1: 12.0601,
    x2: 86.2887,
    y2: 52.6149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_1232",
    x1: 47.845,
    y1: 67.2791,
    x2: 59.7952,
    y2: 83.8452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotobookLink);
export default __webpack_public_path__ + "static/media/photobookLink.52ae37e5b6e69e4784f701d06d6b525b.svg";
export { ForwardRef as ReactComponent };